import React from 'react';
import { useHistory } from 'react-router-dom';
import storyData from '../../assets/stories/Story-1.json';
import './Story1.css';

const Story1: React.FC = () => {
  const history = useHistory();

  return (
    <div className="story1-container">
      <button className="close-button" onClick={() => history.push('/')}>X</button>
      <div className="parchment">
        <h2>{storyData.title}</h2>
        <p>{storyData.text}</p>
        <button className="continue-button" onClick={() => history.push('/story2')}>
          Continue
        </button>
      </div>
    </div>
  );
};

export default Story1;